import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '../Box/Box';
import { Skeleton } from '../Skeleton/Skeleton';
import { Icon, Label, Value } from './components';
/**
 * Description component is used to display a icon, label and a value, usually used inside the paper component.
 */
export const Description = ({ icon, label, value, children, loading, containerProps, size = 'md' }) => {
    if (loading)
        return _jsx(Skeleton, { height: 'md', width: 'xl4' });
    return (_jsxs(Box, { display: 'flex', justifyContent: 'start', alignItems: 'center', ...containerProps, children: [icon && _jsx(Icon, { icon: icon, size: size }), value && _jsx(Value, { value: value, size: size }), label && value && _jsx(Box, { width: 'xxs' }), label && _jsx(Label, { label: label, size: size }), children] }));
};
